import React from 'react';
import { Button, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { getCardImagePath } from '../../../utils/credit-cards';
export const AdditionalCardDetailsModal = ({ card, onConfirmEdit, hideModal, hasHDWallet, }) => {
    const { cardBrand, cardNumberLast4 } = card;
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "Additional Credit Card Details Needed"),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "sui-flex sui-gap-4 sui-flex-col" },
                React.createElement("div", { className: "sui-flex sui-gap-2" },
                    React.createElement("img", { width: 33, height: "auto", src: getCardImagePath(cardBrand, cardBrand), alt: "Credit card logo" }),
                    React.createElement(Typography, null,
                        " ****",
                        cardNumberLast4)),
                React.createElement("div", null,
                    React.createElement(Typography, { variant: "body-base" },
                        "We're missing information for this card that is needed to authorize it for remote purchases",
                        hasHDWallet ? ' and HD Pass' : '',
                        ".")),
                React.createElement("div", null,
                    React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Do you want to edit this card now?")))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: hideModal }, "No"),
                React.createElement(Button, { variant: "primary", onClick: onConfirmEdit }, "Yes, Edit Credit Card")))));
};
